module.exports = __webpack_public_path__ + "img/1106a_3.fe904ff4.jpg";